import Vue from 'vue'

const QUESTION_TYPES = {
    OPEN: 'OPEN',
    SINGLE_CHOICE: 'SINGLE_CHOICE',
    MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
}

async function sendRequest(method, surveyType) {
    const isParent = surveyType === 'parent';

    if (isParent) {
        Vue.http.interceptor.header = (request) => {
            request.headers.set('Authorization', 'Bearer unauthorized')
        }
    }

    const response = method()

    if (isParent) {
        response.then((response) => {
            Vue.http.interceptor.header = undefined

            return response;
        })
    }

    return response;
}

export async function openSurveyAndGetResponse({ targetId, body }, surveyType) {
    return sendRequest(() => new Promise((resolve, reject) => {
        Vue.http.post(`${window.endpoint_survey_response}/${targetId}/open`, JSON.stringify(body))
            .then(function ({ data, status }) {
                resolve({ data, status })
            })
            .catch(function (response) {
                const error = response.body && response.body.message ? response.body.message : 'An error occurred!'
                reject(error)
            })
    }), surveyType)
}

export async function getResponse({ targetId, responseId }, surveyType) {
    return sendRequest(() => Vue.http.get(`${window.endpoint_survey_response}/${targetId}/${responseId}`), surveyType)
}

export async function submitQuestions({ targetId, responseId, body }, surveyType) {
    return sendRequest(() => Vue.http.post(`${window.endpoint_survey_response}/${targetId}/${responseId}/questions`, JSON.stringify(body)), surveyType)
}

export async function closeSurvey({ targetId, responseId, body }, surveyType) {
    return sendRequest(() => Vue.http.post(`${window.endpoint_survey_response}/${targetId}/${responseId}/close`, JSON.stringify(body)), surveyType)
}

function getQuestionType(type) {
    switch (type) {
        case "slider":
        case "multichoice_radio":
            return QUESTION_TYPES.SINGLE_CHOICE
        case "open":
            return QUESTION_TYPES.OPEN
        default:
            return QUESTION_TYPES.MULTIPLE_CHOICE
    }
}

export function getSubmitQuestionsBody(questions) {
    return questions.filter(
        ({ hidden, question_type }) => !hidden && question_type !== 'header_question'
    )
        .map(({ id: questionId, display_type, question_type, comment, answer, ans_comment, is_required }) => {
            const question = {
                questionId,
                type: getQuestionType(question_type),
                comment: comment || undefined,
            }

            switch (question.type) {
                case QUESTION_TYPES.OPEN:
                    question.answerText = answer || '';
                    break;
                case QUESTION_TYPES.SINGLE_CHOICE:
                case QUESTION_TYPES.MULTIPLE_CHOICE:
                    if (display_type === 'dropdown') {
                        answer = answer ? [answer] : []
                    }

                    if (is_required || answer.length > 0) {
                        question.options = answer.map(optionId => {
                            const id = parseInt(optionId, 10);
                            return { id, comment: ans_comment[id] || undefined };
                        })
                    }
                    break;
            }

            return question;
        })
}
